import ComingSoonPage from './ihi_coming_soon_playful_under_construction_page';

function App() {
  return <ComingSoonPage />;
}

export default App;
